import { css } from '@linaria/core';
import theme from '../../../theme';
import { icon } from '../icon/icon.styles';

export const variants = {
  interactive: css``,
};
export const components = {
  btnClose: css``,
};

export const tag = css`
  display: inline-flex;
  justify-content: space-between;
  white-space: nowrap;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  letter-spacing: 2;
  border-width: 1px;
  line-height: 20px;
  gap: 0.5rem;
  background: ${theme.colors.peoople['gris-oscuro']};
  color: white;

  & .${components.btnClose} {
    display: inline-flex;
    align-items: center;
    &:hover {
    }
    & > .${icon}, & > .${icon} {
      line-height: inherit;
      font-size: inherit;
    }
  }

  &[disabled] {
    background: ${theme.colors.neutral['30']};
    color: ${theme.colors.neutral['60']};
    &:hover {
      cursor: not-allowed;
      background: ${theme.colors.neutral['30']};
    }
  }

  &.${variants.interactive} {
    cursor: pointer;
    &:hover {
      background: ${theme.colors.peoople['gris-medio']};
    }
  }
`;
